/* eslint-disable no-unused-vars */
import { CreditCards } from './CreditCards';
import { CreditCard, WireTransfer, PayPal } from 'assets/icons';
import * as S from './AdvertiserPayments.styled';

function openIntercom() {
  if (window.Intercom) window.Intercom('show');
}

export const AdvertiserPayments = () => {
  return (
    <>
      <S.Text>
        Your service will start immediately after adding your payment method, and you pay after you
        accrue costs. <br />
        You will be charged automatically either when your balance reaches a predetermined amount
        ($200 by default), or at the end of the month, whichever comes first.
      </S.Text>
      <S.PaymentMethodsWrap>
        <S.PaymentMethod>
          <S.PaymentIconWrap>
            <CreditCard />
          </S.PaymentIconWrap>
          <S.SubHeading>Credit Card</S.SubHeading>
          <CreditCards />
        </S.PaymentMethod>
        <S.PaymentMethod>
          <S.PaymentIconWrap>
            <WireTransfer />
          </S.PaymentIconWrap>
          <S.SubHeading>Wire Transfer</S.SubHeading>
          <S.SmallText>
            Please process the payment to the bank account mentioned on the invoice.
            <br />
            <br />
            For further information about wire transfers, please contact Appnext support.
            {/* Account Holder: APPNEXT PTE. LTD.
              <br />
              Bank: Barclays Bank Ltd
              <br />
              Branch Identifier: 200605
              <br />
              Swift: BARCGB22
              <br />
              Account Number: 43915622
              <br />
              IBAN: GB98BARC20060543915622
              <br />
              Reference Area: (Enter your full name and company) */}
          </S.SmallText>
        </S.PaymentMethod>
        <S.PaymentMethod>
          <S.PaymentIconWrap>
            <PayPal />
          </S.PaymentIconWrap>
          <S.SubHeading>Pay Pal</S.SubHeading>
          <S.SmallText>
            PayPal processing fees will be included in every transaction.
            <br />
            Payment can be made directly to our PayPal account:{' '}
            <S.ExternalLink
              href='mailto:aint_paypal@affle.com'
              target='_blank'
              rel='noopener nofollow'
            >
              aint_paypal@affle.com
            </S.ExternalLink>
            .
            <br />
            Kindly add your account id or email in the transaction reference, so that funds can be
            added to your account balance.
            <br />
            <br />
            To get more information about Payment please{' '}
            <S.Link onClick={openIntercom}>contact Appnext support</S.Link>
          </S.SmallText>
        </S.PaymentMethod>
      </S.PaymentMethodsWrap>
    </>
  );
};
